import { PartnerPractice } from '@/shared/partner-practice';
import { PartnerPracticeAddress } from '@/shared/partner-practice-address';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { User } from '@/shared/user';
import { State } from '@/stores/partner-practices/state';
import { GetterTree } from 'vuex';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public partnerPractices = (state: State) => {
        return state.partnerPractices.filter((partnerPractice) => !partnerPractice.isArchived);
    }

    public partnerPracticesForCurrentUser = (state: State, getters: Getters, rootState: any, rootGetters: any): Array<PartnerPractice> => {
        const currentUser: User = rootGetters['user/user'];

        if (currentUser == null) {
            return [];
        }

        const partnerPractices: any = getters.partnerPractices;

        return currentUser.partnerPracticeId == null
            ? partnerPractices
            : partnerPractices.filter((partnerPractice: PartnerPractice) => partnerPractice.id === currentUser.partnerPracticeId);
    }

    public partnerPracticeName = (state: State) => (partnerPracticeId: string | null): string => {
        if (partnerPracticeId === '00000000-0000-0000-0000-000000000000') {
            return 'RLG Data';
        }

        const partnerPractice = state.partnerPractices.find((pp) => pp.id! === partnerPracticeId);
        return partnerPractice == null ? '' : partnerPractice.name!;
    }

    public partnerPracticeAddresses = (state: State) => (partnerPracticeId: string | null): Array<PartnerPracticeAddress> => {
        if (partnerPracticeId == null) {
            return [];
        }

        const partnerPractice = state.partnerPractices.find((pp) => pp.id! === partnerPracticeId);
        return partnerPractice == null ? [] : partnerPractice.addresses;
    }

    public partnerPracticeOriginalSourceTypes = (state: State, getters: Getters, rootState: any, rootGetters: any) => (partnerPracticeId: string | null): Array<ClientOriginalSourceType> => {
        const clientOriginalSourceTypes: Array<ClientOriginalSourceType> = rootGetters[`types/activeClientOriginalSourceTypes`];

        if (partnerPracticeId == null) {
            return clientOriginalSourceTypes
                .sort((a, b) => {
                    if (a.value > b.value) { return 1; }
                    if (a.value < b.value) { return -1; }
                    return 0;
                });
        }

        let originalSourceTypeIds: Array<string> = [];

        switch (partnerPracticeId) {
            case '-simpsons-':
                for (const simpsonsPartnerPractice of state.partnerPractices.filter((pp) => pp.isSimpsonsSolicitors)) {
                    for (const originalSourceTypeId of simpsonsPartnerPractice.originalSourceTypes) {
                        if (originalSourceTypeIds.some((id) => id === originalSourceTypeId)) {
                            continue;
                        }

                        originalSourceTypeIds.push(originalSourceTypeId);
                    }
                }

                break;

            case '-partners-':
                for (const partnersPartnerPractice of state.partnerPractices.filter((pp) => !pp.isSimpsonsSolicitors)) {
                    for (const originalSourceTypeId of partnersPartnerPractice.originalSourceTypes) {
                        if (originalSourceTypeIds.some((id) => id === originalSourceTypeId)) {
                            continue;
                        }

                        originalSourceTypeIds.push(originalSourceTypeId);
                    }
                }

                break;

            case '00000000-0000-0000-0000-000000000000':
                originalSourceTypeIds = clientOriginalSourceTypes.filter((type) => type.isValidForAcquisition).map((type) => type.id!);
                break;

            default:
                const partnerPractice = state.partnerPractices.find((pp) => pp.id! === partnerPracticeId);
                originalSourceTypeIds = partnerPractice == null ? [] : partnerPractice.originalSourceTypes;
                break;
        }

        return clientOriginalSourceTypes
            .filter((type) => originalSourceTypeIds.includes(type.id!))
            .sort((a, b) => {
                if (a.value > b.value) { return 1; }
                if (a.value < b.value) { return -1; }
                return 0;
            });
    }
}
